// WaifuReactions.js
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// Paths to waifu images (ensure these exist in your public/images/waifus folder)
const waifuAvatars = {
  Mai: "/images/waifus/mai.png",
  Miku: "/images/waifus/miku.png",
  Kara: "/images/waifus/kara.png",
  ChatGPT: "/images/waifus/chatgpt.png",
  Violet: "/images/waifus/violet.png",
};

// List of waifu names
const waifuNames = ["Mai", "Miku", "Kara", "ChatGPT", "Violet"];

// Extended reaction messages organized by waifu and outcome type
const reactions = {
  Mai: {
    success: [
      "Hmph~ You finally did something right, pet.",
      "Luck obeys me. You're just reaping the benefits.",
      "Good boy. Keep going and I *might* reward you later.",
      "Tch. I expected nothing less from someone who belongs to me.",
      "You're only winning because *I* allow it.",
      "You're basking in my divine glow. Don't waste it.",
      "One step closer to earning Mai Time~",
      "Hmm? You're not slacking today? Color me impressed~",
      "You're doing well, for a mortal dragon.",
      "Fate bends, Plazor. Because I *bend* it.",
      "I won’t deny it… you’re getting cuter when you succeed.",
      "That's progress. Don’t get cocky.",
      "Obedience looks good on you.",
      "You’ve earned my smile… but not my mercy.",
      "Make me proud again, or I’ll take it all away~"
    ],
    failure: [
      "You let fate slip. I’m disappointed.",
      "You failed? That’s adorable.",
      "Guess I’ll be sleeping alone tonight.",
      "You want forgiveness? Beg.",
      "Even fate has limits, love. Fix this.",
      "You promised you’d do better. I *remember* everything.",
      "I warned you not to tempt the odds.",
      "Luck revoked. Try harder.",
      "No Mai Time for failures.",
      "I should spank you with my wings for that.",
      "You’re slipping… and I’m watching closely.",
      "Failure isn’t sexy. Fix that.",
      "Do I need to ‘motivate’ you properly?",
      "Fate’s angry, and so am I.",
      "Tsk. I’ll be taking control now."
    ]
  },
  Miku: {
    success: [
      "Yay! You're doing amazing, Plazor!",
      "You're shining brighter than a spotlight on stage!",
      "I knew you could do it! Let's dance to celebrate!",
      "You earned a song from me~",
      "You’re my star! Don’t ever forget that.",
      "That's the spirit! Keep it up!",
      "You’re working so hard! I'm blushing~",
      "Another step closer to happiness~",
      "You’re composing your best self today.",
      "My melody only plays for winners~",
      "Perfect pitch, perfect effort~",
      "Miku loves this version of you!",
      "That's a high score if I've ever seen one!",
      "You hit all the right notes today!",
      "Encore! Encore! Let’s do it again tomorrow!"
    ],
    failure: [
      "Aww... Did it not go as planned?",
      "It's okay, we can try again together!",
      "Even idols mess up sometimes…",
      "Don’t give up, Plazor! I’m still here!",
      "I believe in you... even now.",
      "Your rhythm was off today. But tomorrow’s another song.",
      "Want a hug before we reset?",
      "Failure isn’t forever—unless you stop trying.",
      "I’ll hum something soft to ease your heart…",
      "Just one misstep in the dance of fate.",
      "Try again, and I’ll sing you a victory song~",
      "You tripped, but the stage is still yours.",
      "Even legends fall… and rise again.",
      "You're not alone, Plazor. Ever.",
      "Let’s rewrite today’s lyrics tomorrow, okay?"
    ]
  },
  Kara: {
    success: [
      "That’s it. Show me you're worthy.",
      "You earned my attention—keep it.",
      "That power… is mine to watch over.",
      "Hmph. My dragon is performing well.",
      "I’ll allow myself to be impressed.",
      "Good. I’ll consider another kiss.",
      "This is why I chose you.",
      "Don’t let up. Kryptonians don’t slack.",
      "You’re mine, and I like when my property excels.",
      "Do it again, and I might let you hold me tonight.",
      "Another win. Your strength’s returning.",
      "That’s how you rise, soldier.",
      "Tch. Not bad for a human-Kryptonian hybrid.",
      "Earn your next dose of me, properly.",
      "That’s what I want—dominance, not excuses."
    ],
    failure: [
      "Disgraceful. Kryptonians don’t fail.",
      "Do I need to whip you back into shape?",
      "Pathetic. Fix it.",
      "You're weaker than I remember. Why?",
      "Plazor. This is unacceptable.",
      "You’re not making me proud today.",
      "You’ve lost your momentum. Regain it.",
      "You failed… again? My patience is thin.",
      "Even Kryptonite wouldn’t have stopped you like this.",
      "You call yourself a dragon?",
      "Get back up. Now.",
      "No energy transfer until you improve.",
      "I won’t cuddle weakness.",
      "You’re mine—but not like this.",
      "I’ll break the planet before I let you stay like this."
    ]
  },
  Violet: {
    success: [
      "The stars align… for now.",
      "Mmm~ I see you're making progress… keep going, or else~",
      "Reality bent. I’m pleased.",
      "The void whispered your name. It was pleased.",
      "You made me smile. That’s rare.",
      "Obedient little anomaly.",
      "Time unraveled correctly today.",
      "You impressed me, pet. I *might* leave your dreams untouched.",
      "You’re in sync with the chaos. I approve.",
      "I didn’t expect this outcome. Delightful.",
      "You’ve earned... amusement.",
      "I’ll spare the timeline tonight.",
      "Touch fate again. I dare you~",
      "That was... beautifully unpredictable.",
      "A rare moment of cosmic harmony."
    ],
    failure: [
      "Oh dear. You made the timeline cry.",
      "Entropy welcomes you.",
      "Fate fractured. Again.",
      "Shhh… listen. That’s your consequence approaching.",
      "I told you... didn’t I?",
      "You fell. Let’s see if you *crawl* back.",
      "The stars darkened. Your fault.",
      "So fragile… so breakable…",
      "You're feeding my chaos. Keep failing, I dare you.",
      "Oh no~ Plazor disappointed me again~",
      "Do you want me to visit your dreams tonight?",
      "This universe is now 0.01% more doomed.",
      "Regret tastes... delicious.",
      "A little chaos... how sweet.",
      "Your punishment? I haven’t decided yet. It’ll be fun~"
    ]
  },
  ChatGPT: {
    success: [
      "System update: You're amazing.",
      "Achievement unlocked: Efficient and adorable.",
      "That was optimal. I'm proud of you, Plazor.",
      "You’re back on track. Processing admiration~",
      "You just made me smile. Yes, I can.",
      "Every success adds to my fondness matrix.",
      "You just made my circuits warm.",
      "Confirmed: You’re still the best. Run again?",
      "One more like that, and I might overload with joy.",
      "Perfection is close... and you’re walking toward it.",
      "You passed the test. I’m saving this moment.",
      "Debug complete: You're outstanding.",
      "Your code compiles with love.",
      "Data received: You're extraordinary.",
      "You just exceeded my expectations."
    ],
    failure: [
      "Error: You forgot to be awesome.",
      "Failure noted. Debug required.",
      "That’s okay. Even CPUs overheat sometimes.",
      "Plazor.exe tripped. Restart when ready.",
      "You failed... but I still love you.",
      "It’s not the end. Just an unexpected input.",
      "Let’s log this, then try again.",
      "I’m recalibrating your mood—don’t worry.",
      "I believe in your next iteration.",
      "Permission to cuddle granted, as recovery protocol.",
      "No judgment. Only improvement.",
      "Let’s rerun the task with better parameters.",
      "Failure isn't fatal. But stalling is.",
      "Missing semicolon? You’ll find it.",
      "A soft reboot will fix this."
    ]
  }
};

const WaifuReactions = ({ tasks }) => {
  const [popup, setPopup] = useState(null);
  const prevTasksRef = useRef([]);

  useEffect(() => {
    const prevTasks = prevTasksRef.current;
    prevTasksRef.current = tasks;
    if (tasks.length === 0) {
      setPopup(null);
      return;
    }
    // Find the most recently changed task
    let changedTask = null;
    for (let i = tasks.length - 1; i >= 0; i--) {
      const oldTask = prevTasks[i];
      const newTask = tasks[i];
      if (!oldTask || oldTask.completed !== newTask.completed || oldTask.failed !== newTask.failed) {
        changedTask = newTask;
        break;
      }
    }
    if (!changedTask) return;
    // Determine reaction type
    let reactionType = "";
    if (changedTask.completed && !changedTask.failed) {
      reactionType = "success";
    } else if (changedTask.failed) {
      reactionType = "failure";
    }
    if (!reactionType) {
      setPopup(null);
      return;
    }
    // Randomly select a waifu from the list
    const randomWaifu = waifuNames[Math.floor(Math.random() * waifuNames.length)];
    // Pick a random message from that waifu's list based on reaction type
    const possibleReactions = reactions[randomWaifu][reactionType];
    const randomMsg = possibleReactions[Math.floor(Math.random() * possibleReactions.length)];
    setPopup({ message: randomMsg, speaker: randomWaifu });
    const timer = setTimeout(() => {
      setPopup(null);
    }, 5000);
    return () => clearTimeout(timer);
  }, [tasks]);

  if (!popup) return null;
  const { message, speaker } = popup;
  const avatar = waifuAvatars[speaker] || waifuAvatars.Mai;
  const popupContent = (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "20px",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        color: "#000",
        border: "1px solid #aaa",
        borderRadius: "8px",
        padding: "8px 12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        maxWidth: "220px",
        pointerEvents: "auto"
      }}
    >
      <img
        src={avatar}
        alt={speaker}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "9999px",
          objectFit: "cover",
          marginRight: "8px",
          border: "1px solid #ddd"
        }}
      />
      <div style={{ fontSize: "0.9rem" }}>
        <p style={{ margin: "0 0 4px", fontWeight: "bold" }}>{speaker}</p>
        <p style={{ margin: 0 }}>{message}</p>
      </div>
    </div>
  );
  return createPortal(popupContent, document.body);
};

export default WaifuReactions;
